module.exports = __webpack_public_path__ + "fonts/Graphik-BlackItalic.a50588b8.ttf";